import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'enumToArray' })
export class EnumToArrayPipe implements PipeTransform {
  transform(
    // REDO: legacy any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _enum: any,
    _sortEnum: boolean = true,
  ): { name: string; value: number | string }[] {
    const enumArray = Object.keys(_enum)
      .filter((key: string) => !isNaN(+key))
      .map((enumValue: string) => +enumValue)
      .map((enumValue: number) => ({
        name: this.pascalCaseToTitleCase(_enum[enumValue]),
        value: enumValue,
      }));

    if (_sortEnum) {
      return enumArray.sort((a, b) => a.name.localeCompare(b.name));
    }
    return enumArray;
  }

  transformToArray<T>(_enum: T): T[keyof T][] {
    return Object.values(_enum).filter(
      (value) => typeof value === 'number',
    ) as T[keyof T][];
  }

  // Maps: PascalCase --> Pascal Case
  private pascalCaseToTitleCase(str: string): string {
    const isUpperCase = (char: string) =>
      char === char.toUpperCase() && char !== char.toLowerCase();

    for (let i = 1; i < str.length; ++i) {
      if (isUpperCase(str[i])) {
        // Insert space before uppercase letter
        str = `${str.slice(0, i)} ${str.slice(i)}`;

        // Skip past uppercase letter
        i += 2;
      }
    }

    return str;
  }
}
